export default "__VITE_ASSET__Bz0itbRl__";